import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { isJwtExists } from "../../../../utils/utility";

const useUserDetailQuery = () => {
  return useQuery({
    queryKey: api.user.getUserDetailKey(),
    queryFn: api.user.getUserDetail,
    select: (res) => res.data.result,
    staleTime: 200,
    enabled: isJwtExists(),
  });
};

export default useUserDetailQuery;
